import lodash from 'lodash';

import { queryGraphQL } from 'common/util/query';
import { nodeWithArgs, node, toQuery, enumeration } from 'common/util/queryHelper';

export const BINDERS_WRITE = 'BINDERS_WRITE';
export const BINDERS_UNLOAD = 'BINDERS_UNLOAD';
export const BINDERS_NOTIFY_LOADING = 'BINDERS_NOTIFY_LOADING';
export const BINDERS_NOTIFY_LOADED = 'BINDERS_NOTIFY_LOADED';
export const BINDERS_INITIAL_OFFSET = 'BINDERS_INITIAL_OFFSET';

export const filterOptions = [
    { displayName: 'Active', gqlName: 'ACTIVE' },
    { displayName: 'Archived', gqlName: 'ARCHIVED' },
    { displayName: 'New', gqlName: 'NEW' }
];

export const sortOptions = [
    { displayName: 'Creation Date', gqlName: 'createdAt' },
    { displayName: 'IRB Number', gqlName: 'irbNumber' },
    { displayName: 'PI', gqlName: 'primaryInvestigator' },
    { displayName: 'Binder Name', gqlName: 'title' },
    { displayName: 'Contact', gqlName: 'contact' },
    { displayName: 'Status', gqlName: 'status' },
    { displayName: 'Trial ID', gqlName: 'trialId' },
    { displayName: 'Trial Type', gqlName: 'trialType' }
];

export function loadBinderOverview(searchOptions, method = 'append') {
    return async (dispatch, getState) => {
        const storeState = getState();
        if (lodash.get(storeState, 'bindersOverview.loading', false)) {
            return;
        }
        dispatch(notifyBindersLoading(true));
        const statusFilter = searchOptions.status ? enumeration(searchOptions.status) : null;
        const binderQuery = nodeWithArgs('binders', {
            queryText: searchOptions.searchString,
            statusFilter: statusFilter,
            sortField: searchOptions.sortField,
            limit: searchOptions.limit,
            offset: searchOptions.offset
        }, [
            'id',
            'title',
            'description',
            'status',
            'createdAt',
            'trialType',
            'primaryInvestigator',
            'irbNumber',
            'contact',
            'trialId',
            'departmentSiteDg',
            'ctGovNumber',
            'sponsorCro',
            'renewalDate',
            node('createdBy', [
                'displayName',
                'emailAddress'
            ]),
            node('institution', [
                'id',
                'displayName',
            ])
        ]);

        const binderCountQuery = nodeWithArgs('bindersCount', {
            queryText: searchOptions.searchString,
            statusFilter: statusFilter
        });

        const results = await queryGraphQL(toQuery([binderQuery, binderCountQuery]));

        if (results.errors) {
            const firstError = lodash.head(results.errors);
            dispatch(notifyBindersLoaded(true, firstError.message));
            return;
        }
        dispatch(writeBinders(results.data.binders, results.data.bindersCount, method));
        dispatch(notifyBindersLoaded(true));
    };
}

export function unloadBinderOverview() {
    return {
        type: BINDERS_UNLOAD
    };
}

export function setInitialOffset(initialOffset) {
    return {
        type: BINDERS_INITIAL_OFFSET,
        payload: initialOffset
    };
}

function notifyBindersLoading(loadingState) {
    return {
        type: BINDERS_NOTIFY_LOADING,
        payload: loadingState
    };
}

function notifyBindersLoaded(loadingState, loadingError = null) {
    return {
        type: BINDERS_NOTIFY_LOADED,
        payload: {
            loadingState,
            loadingError
        }
    };
}

function writeBinders(binders, bindersCount, method) {
    return {
        type: BINDERS_WRITE,
        payload: {
            binders,
            bindersCount,
            method
        }
    };
}